import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../features';
import { actions } from '../../features/reaction';
import { sendEvent } from '../../lib/google-analytics';
import { ReactionItem } from '../../models/ReactionItem';
import { ReactionCell } from './ReactionCell';

interface ReactionListProps {
  items: ReactionItem[];
  isSending?: boolean;
}

export const ReactionList: React.FC<ReactionListProps> = ({ items, isSending }) => {
  const { t } = useTranslation('reaction');
  const dispatch = useDispatch();
  const { selectedReaction } = useSelector((state: RootState) => state.reaction);

  const handleClick = (item: ReactionItem) => () => {
    if (selectedReaction?.place === 'list' && item.label === selectedReaction?.label) {
      dispatch(actions.postReaction(selectedReaction));
      sendEvent('reaction_send_reaction_icon', 'submit', item.label);
    } else {
      dispatch(actions.selectReaction({ ...item, place: 'list' }));
    }
  };

  return (
    <div
      className={css`
        padding: 8px 20px 20px;
        h3 {
          font-size: 14px;
        }
        .list {
          list-style-type: none;
          height: 100%;
          padding: 20px 0;
        }
      `}
    >
      <h3>{t('reaction_list')}</h3>
      <ul className="list">
        {items.map((reaction, i) => (
          <ReactionCell
            key={i}
            name={reaction.name}
            src={reaction.url}
            onClick={handleClick(reaction)}
            isSelected={
              selectedReaction?.place === 'list' && reaction.label === selectedReaction?.label
            }
            isSending={isSending}
          />
        ))}
      </ul>
    </div>
  );
};
